<template>
    <div>
        <main ref="notescontainer" class="flex flex-col h-96 overflow-scroll">
            <div v-for="note in notes" :key="note.id" class="max-w-md mb-4" :class="note.created_by.is_you ? 'ml-8 self-end' : 'mr-8 self-start'">
                <div
                    class="rounded-xl border p-3 flex flex-row last:mb-0 max-w-md"
                    :class="{
                        'bg-brand border-brand-dark text-white': note.created_by.is_you,
                        'bg-gray-50 border-gray-300 text-brand': ! note.created_by.is_you
                    }"
                >
                    <div class="mr-3 flex-shrink-0">
                        <img
                            class="rounded h-6 w-6"
                            :src="(note.created_by || {}).avatar"
                            onerror="this.src='/img/user-placeholder.png';this.onerror='';"
                        />
                    </div>
                    <div>
                        <h3 class="text-xs font-bold" :class="note.created_by.is_you ? 'text-white' : 'text-gray-700'" v-text="note.created_by.name"></h3>
                        <div class="whitespace-pre-wrap" :class="note.created_by.is_you ? 'text-white' : 'text-gray-700'" v-text="note.note"></div>
                    </div>
                </div>
                <div :class="note.created_by.is_you ? 'text-right' : 'text-left'" class="mt-1.5 text-xs">
                    <span class="inline-block text-gray-400 hover:text-gray-500 cursor-pointer" :title="note.created_at_formatted">{{ note.created_at_human }}</span>
                </div>
            </div>
        </main>

        <aside class="mt-6">
            <div class="mt-1 flex rounded-md shadow-sm">
                <div class="relative flex items-stretch flex-grow focus-within:z-10">
                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <img
                            class="rounded w-6 h-6"
                            :src="avatar_url"
                            onerror="this.src='/img/user-placeholder.png';this.onerror='';"
                        />
                    </div>
                    <input
                        v-model="note"
                        type="text"
                        class="focus:ring-brand focus:border-brand block w-full mb-0 rounded-none rounded-l-md pl-12 sm:text-sm border-gray-300"
                        placeholder="Enter note here..."
                        @keyup.enter="addNote()"
                    >
                </div>
                <button @click.prevent="addNote()" class="-ml-px relative inline-flex items-center space-x-2 px-4 py-1 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand">
                    <i class="fas fa-caret-right"></i>
                    <span>Send</span>
                </button>
            </div>
        </aside>
    </div>
</template>

<script>
    export default {
        props: ['getUrl', 'postUrl'],
        data() {
            return {
                notes: [],
                note: ''
            }
        },
        watch:{
            getUrl () {
                this.getNotes();
            },
            postUrl () {
                this.getNotes();
            }
        },
        computed: {
          avatar_url(){
            return appData.user.avatar_url;
          }
        },
        methods: {
            scrollToBottom(){
                var container = this.$refs.notescontainer;

                // We need to delay this a little bit to allow the browser time to render
                // the new data before we actually scroll to the bottom of the container.
                setTimeout(function () {
                    container.scrollTop = container.scrollHeight;
                }, 100);
            },
            addNote() {
                var that = this;
                var note = this.note;
                this.note = '';
                axios.post(this.postUrl, {note: note})
                    .then(response => {
                        that.notes.push(response.data.data);
                        that.scrollToBottom();
                    });
            },
            getNotes() {
                var that = this;
                axios.get(this.getUrl)
                    .then(response => {
                        that.notes = response.data.data;
                        that.scrollToBottom();
                    });
            }
        },
        mounted() {
            this.getNotes();
        }
    }
</script>
